import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "asset-sidebar" }
const _hoisted_2 = { class: "asset-sidebar__tabs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "asset-sidebar__tab-icon icon icon--message-circle--thin" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "asset-sidebar__tab-icon icon icon--eye--thin" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "asset-sidebar__tab-icon icon icon--history--thin" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "asset-sidebar__tab-icon icon icon--settings--thin" }, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "asset-sidebar__content-wrapper" }
const _hoisted_12 = { class: "p" }
const _hoisted_13 = { class: "flex flex--justify-space-between mb-16" }
const _hoisted_14 = { class: "asset-sidebar__sub-title" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_16 = {
  key: 0,
  class: "typeset typeset--small mb-16"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, " Project is now complete and further commenting has been disabled. ", -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "typeset typeset--small mb-16"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, " Asset is final and further commenting has been disabled. ", -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 2,
  class: "typeset typeset--small mb-16"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, " This upload is not approved yet so commenting has been disabled. ", -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 3,
  class: "typeset typeset--small mb-16"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, " This stage has been completed and further commenting has been disabled. ", -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "asset-sidebar__comments-heading" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", { class: "asset-sidebar__sub-title" }, " Comments ", -1 /* HOISTED */)
const _hoisted_30 = { key: 5 }
const _hoisted_31 = { class: "asset-sidebar__approvals-heading" }
const _hoisted_32 = { class: "asset-sidebar__sub-title" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_34 = { class: "asset-sidebar__approvals-sub-heading" }
const _hoisted_35 = { class: "asset-sidebar__sub-sub-title" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_37 = { class: "asset-sidebar__approvals-sub-heading" }
const _hoisted_38 = { class: "asset-sidebar__sub-sub-title" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_40 = { class: "asset-sidebar__history-heading" }
const _hoisted_41 = { class: "asset-sidebar__sub-title" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_43 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_CommentFormComponent = _resolveComponent("CommentFormComponent")
  const _component_TabNavigationComponent = _resolveComponent("TabNavigationComponent")
  const _component_CommentsComponent = _resolveComponent("CommentsComponent")
  const _component_ApprovalsComponent = _resolveComponent("ApprovalsComponent")
  const _component_AssetHistoryComponent = _resolveComponent("AssetHistoryComponent")
  const _component_DeleteOptionModalComponent = _resolveComponent("DeleteOptionModalComponent")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["asset-sidebar__tab", { 'asset-sidebar__tab--active': $data.active_tab === 'comments' && $props.expand }]),
        onClick: _cache[0] || (_cache[0] = $event => ($options.toggleActiveTab( 'comments' )))
      }, _hoisted_4, 2 /* CLASS */),
      _createElementVNode("button", {
        class: _normalizeClass(["asset-sidebar__tab", { 'asset-sidebar__tab--active': $data.active_tab === 'approvals' && $props.expand }]),
        onClick: _cache[1] || (_cache[1] = $event => ($options.toggleActiveTab( 'approvals' )))
      }, _hoisted_6, 2 /* CLASS */),
      _createElementVNode("button", {
        class: _normalizeClass(["asset-sidebar__tab asset-sidebar__tab--history", { 'asset-sidebar__tab--active': $data.active_tab === 'history' && $props.expand }]),
        onClick: _cache[2] || (_cache[2] = $event => ($options.toggleActiveTab( 'history' )))
      }, _hoisted_8, 2 /* CLASS */),
      ($data.user_is_staff_super_admin)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["asset-sidebar__tab", { 'asset-sidebar__tab--active': $data.active_tab === 'settings' && $props.expand }]),
            onClick: _cache[3] || (_cache[3] = $event => ($options.toggleActiveTab( 'settings' )))
          }, _hoisted_10, 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        class: _normalizeClass(["asset-sidebar__content", { 'asset-sidebar__content--loading': $data.loading }])
      }, [
        _createElementVNode("h2", _hoisted_12, _toDisplayString($options.sidebar_title), 1 /* TEXT */),
        ($data.active_tab === 'comments' && $data.option)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h3", _hoisted_14, [
                  _createTextVNode(_toDisplayString($options.image_title[0]) + " ", 1 /* TEXT */),
                  _hoisted_15,
                  _createTextVNode(" " + _toDisplayString($options.image_title[1]), 1 /* TEXT */)
                ]),
                ($data.active_tab === 'comments')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "arrow-link p--small",
                      to: {
								name: 'projects__project',
								params: { project_id: this.$route.params.project_id },
								query: { tab: 'discussion' }
							}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" All discussions ")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"]))
                  : _createCommentVNode("v-if", true)
              ]),
              ($data.project_is_completed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                : ($options.asset_is_final)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                  : ($options.option_is_staff_unapproved)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                    : ($options.option_is_in_old_stage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                      : (_openBlock(), _createBlock(_component_CommentFormComponent, {
                          key: 4,
                          "option-id": $options.option_id,
                          onCommentPosted: $options.getComments
                        }, null, 8 /* PROPS */, ["option-id", "onCommentPosted"])),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                ($options.filtered_comments && $options.filtered_comments.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(["comments-sort", { 'comments-sort--asc': $data.date_sort === 'asc' }]),
                      onClick: _cache[4] || (_cache[4] = (...args) => ($options.toggleDateSort && $options.toggleDateSort(...args)))
                    }, " Date ", 2 /* CLASS */))
                  : _createCommentVNode("v-if", true)
              ]),
              ($setup.active_version_id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createVNode(_component_TabNavigationComponent, {
                      tabs: $options.filter_tabs,
                      "active-tab": $data.active_filter_tab,
                      slim: true,
                      "reduced-margin": true,
                      theme: "white-on-dark",
                      onSetTab: $options.setActiveFilterTab
                    }, null, 8 /* PROPS */, ["tabs", "active-tab", "onSetTab"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_CommentsComponent, {
                comments: $options.filtered_comments,
                "show-tags": true
              }, null, 8 /* PROPS */, ["comments"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($data.active_tab === 'approvals' && $data.option)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("h3", _hoisted_32, [
                  _createTextVNode(_toDisplayString($options.image_title[0]) + " ", 1 /* TEXT */),
                  _hoisted_33,
                  _createTextVNode(" " + _toDisplayString($options.image_title[1]), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("h4", _hoisted_35, [
                  _createTextVNode(" Artist: "),
                  _hoisted_36,
                  _createTextVNode(" " + _toDisplayString($options.option_artist), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("h4", _hoisted_38, [
                  _createTextVNode(" Uploaded on " + _toDisplayString($options.option_upload_date) + " by: ", 1 /* TEXT */),
                  _hoisted_39,
                  _createTextVNode(" " + _toDisplayString($options.option_uploader), 1 /* TEXT */)
                ])
              ]),
              _createVNode(_component_ApprovalsComponent, { option: $data.option }, null, 8 /* PROPS */, ["option"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($data.active_tab === 'history' && $data.asset)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("h3", _hoisted_41, [
                  _createTextVNode(_toDisplayString($options.image_title[0]) + " ", 1 /* TEXT */),
                  _hoisted_42,
                  _createTextVNode(" " + _toDisplayString($options.image_title[1]), 1 /* TEXT */)
                ])
              ]),
              _createVNode(_component_AssetHistoryComponent, { asset: $data.asset }, null, 8 /* PROPS */, ["asset"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        ($data.active_tab === 'settings' && $data.option)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("button", {
                class: _normalizeClass(["button button--fill-danger", { 'button--disabled': $data.loading || $options.asset_is_final || $options.option_is_in_old_stage }]),
                disabled: $data.loading || $options.asset_is_final || $options.option_is_in_old_stage,
                onClick: _cache[5] || (_cache[5] = $event => ($data.show_delete_option_modal = true))
              }, " Delete selected option ", 10 /* CLASS, PROPS */, _hoisted_43),
              (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    ($data.show_delete_option_modal)
                      ? (_openBlock(), _createBlock(_component_DeleteOptionModalComponent, {
                          key: 0,
                          option: $data.option,
                          onOptionDeleted: $options.refreshAssetView,
                          onCloseModal: _cache[6] || (_cache[6] = $event => ($data.show_delete_option_modal = false))
                        }, null, 8 /* PROPS */, ["option", "onOptionDeleted"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ])
  ]))
}